import { render, staticRenderFns } from "./CustomTableItem.vue?vue&type=template&id=6adf82d9&scoped=true&"
import script from "./CustomTableItem.vue?vue&type=script&lang=ts&"
export * from "./CustomTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTableItem.vue?vue&type=style&index=0&id=6adf82d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf82d9",
  null
  
)

export default component.exports